import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledPasswordInput from '../../../generic/Forms/LabeledPasswordInput';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { NugetSource } from '../../../../../typings/auth';

type SourceProps = {
  source: NugetSource;
  onUpdateSource: <K extends keyof NugetSource>(member: K, value: NugetSource[K]) => void;
  onRemoveSource: () => void;
};

const Source: VoidFunctionComponent<SourceProps> = ({
  source,
  onUpdateSource,
  onRemoveSource,
}) => {
  return (
    <div className="margin-bottom-sm">
      <FormGroup direction="row" spacing="sm" baselineAlignment>
        <LabeledTextInput
          labelVariant="legacy"
          label="URL"
          size="small"
          value={source.url || ''}
          onChange={value => onUpdateSource('url', value)}
          placeholder="https://github.com/org/repo"
        />
        <LabeledTextInput
          labelVariant="legacy"
          label="Username"
          size="small"
          value={source.username || ''}
          onChange={value => onUpdateSource('username', value)}
          placeholder="someuser"
        />
        <LabeledPasswordInput
          label="Password"
          size="small"
          value={source.hasPassword ? '••••••••' : source.password?.value || ''}
          onChange={value => onUpdateSource('password', { __type: 's', value })}
        />
        <Button
          type="error"
          size="small"
          onClick={onRemoveSource}
        >
          Remove
        </Button>
      </FormGroup>
    </div>
  );
};

export default Source;
